import OriginationChannelType from "./OriginationChannelTypeEnum";
import IMerchantURLs from "./IMerchantURLs";
import IOriginationChannel from "./IOriginationChannel";
import IChannelPhoneSettings from "./IChannelPhoneSettings";

export default class OriginationChannel implements IOriginationChannel {
    constructor(
        public type: OriginationChannelType = OriginationChannelType.ONLINE,
        public online?: IMerchantURLs,
        public phone?: IChannelPhoneSettings,
    ) {}
}
